export default {
  id: 241,
  title: 'Target #241 - Mint Typewriter',
  url: 'https://cssbattle.dev/play/241',
  colors: ['#3D3824', '#86C78D', '#F7FFCF'],
  solution:
    '<i a><i b><i c><style>i[a],i[b]{height:110;border-radius:10px}i[a],i[b],i[c]{border-radius:10px}*{background:#3d3824}i{position:fixed}i[a]{top:125;left:60;width:280;background:#f7ffcf}i[b]{top:85;left:80;width:240;background:linear-gradient(#f7ffcf 40px,#86c78d 40px)}i[c]{top:65;left:100;width:200;height:40;background:linear-gradient(#86c78d 20px,#3d3824 20px)',
}
